// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1J0ms","iconWrapper":"styles_iconWrapper__1vNJO","icon":"styles_icon__VdD5C","title":"styles_title__1uVvL"};